module.exports = __webpack_public_path__ + "img/scoremaster_share.6b43acee.jpg";